import { z } from 'zod';

export const thcLimitResDto = z.object({
  thcLimit: z.number(),
  createdAt: z.coerce.date(), // this is either the beginning of the month, when the thcLimit was set, or 01.01.1970 if no limit was ever set
  unit: z.string(),
});
export type ThcLimitResDto = z.infer<typeof thcLimitResDto>;
